import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Grid as MuiGrid, Typography as MuiTypography } from "@mui/material";
import { FilterPanel } from "app/shared/ui/FilterPanel";
import { FacultyLeave } from "./FacultyLeave";
import { FacultyLeaveFilter } from "./FacultyLeaveFilters";

export const FacultyLeavePage = () => {
  const { t } = useTranslation();
  const [open, setOpen] = useState(true);

  // Function to handle the drawer toggle
  function handleDrawerToggle() {
    setOpen(!open);
  }

  return (
    <MuiGrid
      id="faculty-leave-page"
      container
      wrap="nowrap"
      sx={{ width: "100%", gap: "24px" }}
    >
      <MuiGrid
        container
        sx={{
          minWidth: open ? "300px" : "32px",
          maxWidth: open ? "300px" : "32px",
        }}
      >
        <FilterPanel open={open} handleDrawerToggle={handleDrawerToggle}>
          <FacultyLeaveFilter />
        </FilterPanel>
      </MuiGrid>
      <MuiGrid
        container
        spacing={2}
        wrap="nowrap"
        direction="column"
        sx={{ paddingTop: "24px", width: "100%" }}
      >
        <MuiGrid size={12}>
          <MuiTypography variant="h1">{t("FLA.mainView.title")}</MuiTypography>
        </MuiGrid>
        <MuiGrid size={12}>
          <FacultyLeave />
        </MuiGrid>
      </MuiGrid>
    </MuiGrid>
  );
};
